import React from 'react';
import { formatNumber } from '../../utils/constants';

export const ReceivablesTab = ({ receivables, receivablesTotal }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Accounts Receivable (Outstanding Orders)</h3>
      <p className="text-sm text-muted-foreground mb-4">Orders that have not been fully paid appear here as receivables.</p>
      {receivables.items?.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full" data-testid="receivables-table">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Customer</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Order</th>
                <th className="text-right py-3 px-4 text-sm font-medium text-muted-foreground">Total</th>
                <th className="text-right py-3 px-4 text-sm font-medium text-muted-foreground">Paid</th>
                <th className="text-right py-3 px-4 text-sm font-medium text-muted-foreground">Balance Due</th>
              </tr>
            </thead>
            <tbody>
              {receivables.items.map(item => (
                <tr key={item.id} className="border-b border-border hover:bg-muted/30">
                  <td className="py-3 px-4 font-medium">{item.customer_name}</td>
                  <td className="py-3 px-4 text-muted-foreground font-mono text-sm">{item.id?.slice(0, 8)}...</td>
                  <td className="py-3 px-4 text-right">{formatNumber(item.total)}</td>
                  <td className="py-3 px-4 text-right text-emerald-600">{formatNumber(item.amount_paid || 0)}</td>
                  <td className="py-3 px-4 text-right font-semibold text-amber-600">{formatNumber(item.balance_due)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-muted/30 font-semibold">
                <td colSpan={4} className="py-3 px-4">Total Receivables</td>
                <td className="py-3 px-4 text-right text-amber-600">RWF {formatNumber(receivablesTotal)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      ) : (
        <p className="text-center text-muted-foreground py-8">No outstanding receivables. All orders have been paid.</p>
      )}
    </div>
  );
};
